import { UserInfo } from '@/services/AuthService.interface'
import { LocaleStorageKey } from '@/config/localeStorageKey'

const setUserIdInLocalStorage = (userInfo: UserInfo) => {
  localStorage.setItem(LocaleStorageKey.USER_ID, userInfo.iresa_id)
}

export default setUserIdInLocalStorage
